import { Tile } from 'common/tile/tile.js';
import { Glossary, IGlossary } from 'components/glossary/glossary.js';
import { IModule } from 'redux-state/layout/types.js';

export const GlossaryModule = ({ config }: IModule<IGlossary>) => {
  const { sections } = config;

  return (
    <Tile dataModule="glossary" config={config}>
      <div className="Tile-body">
        <Glossary sections={sections} />
      </div>
    </Tile>
  );
};
